import { useRequestPageSize } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/__internal__/useRequestPageSize";
import { useCategoryPageQuery } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPageQuery/useCategoryPageQuery";
import { useIsCategoryPageLoading } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useIsCategoryPageLoading";
import { useMemo } from "react";
export var useCategoryPageBrandFirstSearchResults = function() {
    var _useCategoryPageQuery_data;
    var requestPageSize = useRequestPageSize();
    var isLoading = useIsCategoryPageLoading();
    var tiles = (_useCategoryPageQuery_data = useCategoryPageQuery().data) === null || _useCategoryPageQuery_data === void 0 ? void 0 : _useCategoryPageQuery_data.brands;
    return useMemo(function() {
        if (isLoading) {
            return [];
        }
        var _tiles_slice;
        return (_tiles_slice = tiles === null || tiles === void 0 ? void 0 : tiles.slice(0, requestPageSize)) !== null && _tiles_slice !== void 0 ? _tiles_slice : [];
    }, [
        isLoading,
        requestPageSize,
        tiles
    ]);
};
